module.exports = __webpack_public_path__ + "static/media/ins-bg-tablet-low.528ae9a2.jpg";